import { BorderRadiusToken, TRadius } from './radius'
import { BorderWidthToken, TWidth } from './width'

export default {
  radius: BorderRadiusToken,
  width: BorderWidthToken,
}

export type TBorderV2 = TRadius | TWidth
